import QuestionHeader from "components/feedback/QuestionHeader";
import TextFeedback from "components/feedback/TextFeedback";
import { QuestionType } from "enums/form";
import Markdown from "react-markdown";
import { Feedback } from "types/feedback";

type PulseSurveySheetContentProps = {
  feedbacks: Feedback[] | undefined;
  emptyMessage?: string;
};

const PulseSurveySheetContent = ({
  feedbacks,
  emptyMessage = "There is no feedback for this cycle.",
}: PulseSurveySheetContentProps) => {
  const feedback = feedbacks?.[0];

  if (!feedback) {
    return <p className="body-14-regular text-neutral-50">{emptyMessage}</p>;
  }

  const sortedAnswers = [...feedback.answers].sort(
    (a, b) => a.question.sequence - b.question.sequence,
  );

  return (
    <article className="space-y-5 rounded-2xl bg-blue-10 p-6">
      {sortedAnswers.map((answer) => {
        const { question } = answer;

        return (
          <div
            key={answer.id}
            className="border-b border-neutral-20 pb-3 last:border-b-0 last:pb-0"
          >
            <QuestionHeader
              sequence={question.sequence}
              label={question.label}
              hint={question.hint}
            />
            {question.questionType === QuestionType.TEXT ? (
              <TextFeedback
                answer={answer}
                className="body-14-regular break-words text-neutral-200"
              />
            ) : (
              <p className="body-14-regular break-words text-neutral-200">
                <Markdown>{answer.answerOptions?.label ?? "—"}</Markdown>
              </p>
            )}
          </div>
        );
      })}
    </article>
  );
};

export default PulseSurveySheetContent;
